<template>
	<section class="meal-plan-settings mt-5">
		<h3>Meal Plan Settings</h3>
		<div class="mb-3">
			<label for="cookForNumPeople" class="form-label"
				>Cooking for how many people?</label
			>
			<input
				type="number"
				:class="[
					'form-control',
					props.transparent && 'transparent-form-control',
				]"
				id="cookForNumPeople"
				v-model="modelValue.cookForNumPeople" />
		</div>
		<div class="mb-3">
			<label for="timesToEatOut" class="form-label">Times to Eat Out</label>
			<input
				type="number"
				:class="[
					'form-control',
					props.transparent && 'transparent-form-control',
				]"
				id="timesToEatOut"
				v-model="modelValue.timesToEatOut" />
		</div>
		<div class="mb-3">
			<label for="diet" class="form-label">Preset Diet</label>
			<select
				:class="[
					'form-select',
					props.transparent && 'transparent-form-control',
				]"
				id="diet"
				v-model="selectedDiet"
				@change="handleDietChange">
				<option value="">Select a diet</option>
				<option value="FDA MyPlate">FDA MyPlate</option>
				<option value="Atkins diet">Atkins</option>
				<option value="Low carb diet">Low Carb</option>
				<option value="High protiend diet">High Protein</option>
				<option value="Low sodium diet">Low Sodium</option>
				<option value="Intermittent fasting diet - Please define schedule">
					Intermittent Fasting
				</option>
			</select>
		</div>
		<div class="mb-3">
			<label for="describeDiet" class="form-label">Describe your diet</label>
			<textarea
				:class="[
					'form-control',
					props.transparent && 'transparent-form-control',
				]"
				id="describeDiet"
				rows="3"
				v-model="modelValue.dietDescription"></textarea>
		</div>
		<div class="mb-3">
			<label for="dislikes" class="form-label">Dislike</label>
			<textarea
				:class="[
					'form-control',
					props.transparent && 'transparent-form-control',
				]"
				id="dislikes"
				rows="3"
				v-model="modelValue.dislikes"></textarea>
		</div>
		<div class="mb-3">
			<label for="likes" class="form-label">Like</label>
			<textarea
				:class="[
					'form-control',
					props.transparent && 'transparent-form-control',
				]"
				id="likes"
				rows="3"
				v-model="modelValue.likes"></textarea>
		</div>
		<div class="mb-3">
			<label for="additionalInfo" class="form-label">Additional Info</label>
			<textarea
				:class="[
					'form-control',
					props.transparent && 'transparent-form-control',
				]"
				id="additionalInfo"
				rows="3"
				v-model="modelValue.additionalInfo"></textarea>
		</div>
	</section>
</template>

<script setup>
	import { ref, watch } from "vue"

	const props = defineProps({
		modelValue: {
			type: Object,
			required: true,
		},
		transparent: {
			type: Boolean,
			default: false,
		},
	})

	const emit = defineEmits(["update:modelValue"])

	const selectedDiet = ref("")

	const handleDietChange = () => {
		const newValue = { ...props.modelValue }
		newValue.dietDescription = selectedDiet.value
		emit("update:modelValue", newValue)
		selectedDiet.value = ""
	}
</script>

<style scoped>
	.meal-plan-settings {
		margin-bottom: 2rem;
	}

	h3 {
		margin-bottom: 1rem;
	}

	.form-label {
		font-weight: bold;
	}

	/* Transparent inputs for this view */
	.transparent-form-control {
		background-color: transparent !important;
		color: #ffffff !important;
		border-color: rgba(255, 255, 255, 0.25);
	}
	.transparent-form-control:focus {
		background-color: transparent !important;
		color: #ffffff !important;
		box-shadow: 0 0 0 0.2rem rgba(34, 197, 94, 0.25);
		border-color: #22c55e;
	}
</style>
